import { Routes } from '@angular/router';
import { ErrorPageComponent, ExternalLoginComponent } from './components';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'smartrfit/residential',
    pathMatch: 'full' as const,
  },
  {
    path: 'smartrfit',
    loadChildren: () => import('./smartrfit/smartrfit.module').then((m) => m.SmartrFitModule),
  },
  {
    path: 'loginexternal',
    component: ExternalLoginComponent,
  },
  { path: 'error', component: ErrorPageComponent },
];
